import { timer } from 'rxjs';

const ticker$ = (intervalInMilliseconds = 1000) =>
    timer(0, intervalInMilliseconds);

export default ticker$;
